interface Props {
  className?: string;
}

export default function FlagIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 11 17"
      fill="white"
      stroke="white"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99999 15V1.2C9.99999 1.08954 9.91045 1 9.79999 1H1.20013C1.08967 1 1.00013 1.08954 1.00013 1.2L1 8V15L5.50006 11.0625L9.99999 15Z"
        stroke="currentColor"
      />
    </svg>
  );
}
